import React from "react";
import { CiSearch } from "react-icons/ci";
import { BackButton, SubTitle } from "../../../Components/CustomComponents";
import { campaignLabel } from "../../Dashboard/constants/labels";
import styles from "../styles/campaignNotifications.module.scss";

export default function CampaignUsersHeader({
  campaign,
  search,
  onSearch,
  onBack,
}) {
  return (
    <div className={styles.usersHeader}>
      <div className={styles.backWrap}>
        <BackButton isRelative handleBackButton={onBack} />
      </div>
      <div className={styles.headerCopy}>
        <SubTitle
          text={campaignLabel(campaign?.slug, campaign?.name)}
          classes="primary-text"
        />
        <p className={styles.hint}>
          Review sent users, pick eligible users, or choose from every user.
        </p>
      </div>
      <label className={styles.usersSearch}>
        <CiSearch aria-hidden="true" />
        <input
          type="search"
          value={search}
          onChange={(event) => onSearch(event.target.value)}
          placeholder="Search by name, username, or email"
          aria-label="Search users"
        />
      </label>
    </div>
  );
}
